import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../apollo-client';
import {appHistory} from '../history';
import {store} from '../store';
import {UnsubscribeRoot} from '../ui/email-marketing-unsubscribe/unsubscribe-root';

import 'less/auth.less';

const mountDiv = document.querySelector('#unsubscribe-react-mount');
if (mountDiv) {
    // Get the data thats passed from PHP. This is kinda a hack, we would prefer
    // to do this in GraphQL, but thats not really set up to be used in an
    // unauthed environment so here we are. Also, for some reason, the variables
    // even when they use camel case come through all lower case, thus the
    // naming
    const emailAddress =
        // @ts-expect-error
        mountDiv.dataset.emailaddress && mountDiv.dataset.emailaddress.length
            ? // @ts-expect-error
              mountDiv.dataset.emailaddress
            : undefined;
    // @ts-expect-error
    const showSuccessBanner = mountDiv.dataset.showsuccessbanner
        ? // @ts-expect-error
          mountDiv.dataset.showsuccessbanner === '1'
        : false;
    // @ts-expect-error
    const isGloballyUnsubscribed = mountDiv.dataset.isgloballyunsubscribed
        ? // @ts-expect-error
          mountDiv.dataset.isgloballyunsubscribed === '1'
        : false;
    const campaignName =
        // @ts-expect-error
        mountDiv.dataset.campaignname && mountDiv.dataset.campaignname.length
            ? // @ts-expect-error
              mountDiv.dataset.campaignname
            : undefined;
    const unsubscribeUrl =
        // @ts-expect-error
        mountDiv.dataset.unsubscribeurl && mountDiv.dataset.unsubscribeurl.length
            ? // @ts-expect-error
              mountDiv.dataset.unsubscribeurl
            : undefined;
    // @ts-expect-error
    const preferencesUrl = mountDiv.dataset.preferencesurl
        ? // @ts-expect-error
          mountDiv.dataset.preferencesurl
        : undefined;
    // @ts-expect-error
    const allowAudienceUnsubscribe = mountDiv.dataset.allowaudienceunsubscribe
        ? // @ts-expect-error
          mountDiv.dataset.allowaudienceunsubscribe === '1'
        : false;
    const companyName =
        // @ts-expect-error
        mountDiv.dataset.companyname && mountDiv.dataset.companyname.length
            ? // @ts-expect-error
              mountDiv.dataset.companyname
            : undefined;
    const isGeneric =
        // @ts-expect-error
        mountDiv.dataset.isgeneric && mountDiv.dataset.isgeneric.length
            ? // @ts-expect-error
              mountDiv.dataset.isgeneric
            : undefined;
    // @ts-expect-error
    const publicAudiences = mountDiv.dataset.publicaudiences
        ? // @ts-expect-error
          JSON.parse(mountDiv.dataset.publicaudiences)
        : [];
    // @ts-expect-error
    const currentAudience = mountDiv.dataset.currentaudience
        ? // @ts-expect-error
          JSON.parse(mountDiv.dataset.currentaudience)
        : undefined;

    ReactDOM.render(
        <Provider store={store}>
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <Router history={appHistory}>
                        <UnsubscribeRoot
                            emailAddress={emailAddress}
                            showSuccessBanner={showSuccessBanner}
                            isGloballyUnsubscribed={isGloballyUnsubscribed}
                            campaignName={campaignName}
                            unsubscribeUrl={unsubscribeUrl}
                            preferencesUrl={preferencesUrl}
                            allowAudienceUnsubscribe={allowAudienceUnsubscribe}
                            companyName={companyName}
                            isGeneric={isGeneric}
                            publicAudiences={publicAudiences}
                            currentAudience={currentAudience}
                        />
                    </Router>
                </ReactHooksApolloProvider>
            </ApolloProvider>
        </Provider>,
        mountDiv
    );
}
